/*
 * sections/blog-posts.liquid - carousel arrows (desktop) and arrow positioning.
 * Loaded with `defer`; initialises every `.inv-blog-section` on the page and
 * re-initialises a section the theme editor reloads.
 */
(function () {
  if (window.invBlogCarouselInit) return;
  window.invBlogCarouselInit = true;

  function initializeBlogCarousel(sectionElement) {
    if (!sectionElement) return;

    var carousel = sectionElement.querySelector('[data-blog-carousel]');
    var scroller = sectionElement.querySelector('.custom-blog-slider');
    var previousButton = sectionElement.querySelector('.custom-blog-arrow--prev');
    var nextButton = sectionElement.querySelector('.custom-blog-arrow--next');

    if (!carousel || !scroller || !previousButton || !nextButton || carousel.dataset.initialized === 'true') {
      return;
    }

    carousel.dataset.initialized = 'true';

    function isDesktop() {
      return window.innerWidth > 768;
    }

    function getVisibleCards() {
      return Array.prototype.filter.call(scroller.querySelectorAll('.custom-blog-card'), function (card) {
        return card.offsetParent !== null;
      });
    }

    function updateArrowPosition() {
      var cards = getVisibleCards();

      if (!cards.length) return;

      var carouselRect = carousel.getBoundingClientRect();
      var scrollerRect = scroller.getBoundingClientRect();
      var firstCardRect = cards[0].getBoundingClientRect();

      var previousLeft = scrollerRect.left - carouselRect.left;

      var nextLeft = scrollerRect.right - carouselRect.left;

      var arrowTop = firstCardRect.top - carouselRect.top + firstCardRect.height / 2;

      carousel.style.setProperty('--blog-arrow-prev-left', previousLeft + 'px');

      carousel.style.setProperty('--blog-arrow-next-left', nextLeft + 'px');

      carousel.style.setProperty('--blog-arrow-top', arrowTop + 'px');
    }

    function updateButtons() {
      var maximumScrollLeft = Math.max(0, Math.round(scroller.scrollWidth - scroller.clientWidth));

      var hasScrollableContent = maximumScrollLeft > 5;

      if (!isDesktop() || !hasScrollableContent) {
        previousButton.style.display = 'none';
        nextButton.style.display = 'none';

        previousButton.disabled = true;
        nextButton.disabled = true;
        return;
      }

      previousButton.style.display = '';
      nextButton.style.display = '';

      var currentScrollLeft = Math.round(scroller.scrollLeft);
      var threshold = 20;

      previousButton.disabled = currentScrollLeft <= threshold;

      nextButton.disabled = currentScrollLeft >= maximumScrollLeft - threshold;
    }

    function getScrollDistance() {
      var cards = getVisibleCards();

      if (!cards.length) {
        return scroller.clientWidth * 0.8;
      }

      var firstCard = cards[0];
      var secondCard = cards[1];

      if (secondCard) {
        return Math.round(secondCard.getBoundingClientRect().left - firstCard.getBoundingClientRect().left);
      }

      var sliderStyles = window.getComputedStyle(scroller);
      var gap = parseFloat(sliderStyles.columnGap || sliderStyles.gap) || 0;

      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateAfterLayout() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          // The arrows are hidden below 769px, so skip the layout reads there
          // (each one forces a style/layout flush of the whole page on load).
          if (isDesktop()) updateArrowPosition();
          updateButtons();
        });
      });
    }

    previousButton.addEventListener('click', function () {
      if (!isDesktop()) return;

      scroller.scrollBy({
        left: -getScrollDistance(),
        behavior: 'smooth',
      });
    });

    nextButton.addEventListener('click', function () {
      if (!isDesktop()) return;

      scroller.scrollBy({
        left: getScrollDistance(),
        behavior: 'smooth',
      });
    });

    scroller.addEventListener('scroll', updateButtons, {
      passive: true,
    });

    window.addEventListener('resize', updateAfterLayout);
    window.addEventListener('load', updateAfterLayout);

    updateAfterLayout();

    window.setTimeout(updateAfterLayout, 100);
    window.setTimeout(updateAfterLayout, 300);
  }

  function initializeAll() {
    document.querySelectorAll('.inv-blog-section').forEach(initializeBlogCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('inv-blog-section')) {
      initializeBlogCarousel(event.target);
    }
  });
})();
